const moradores = [
    {
        nome: "Biel",
        curso: "Engenharia Física, UFSCar",
        ano: "2019",
        foto: "6",
        insta: "https://www.instagram.com/jacobs_gabriel",
    },
    {
        nome: "Dog",
        curso: "Engenharia Elétrica, CAASO",
        ano: "2019",
        foto: "18",
        insta: "https://www.instagram.com/matheusjacobsem",
    },
    {
        nome: "Xupeta",
        curso: "Processos Gerenciais, IFSP",
        ano: "2019",
        foto: "8",
        insta: "https://www.instagram.com/lucasguerrasc",
    },
    {
        nome: "Igart",
        curso: "Química, UFSCar",
        ano: "2019",
        foto: "19",
        insta: "https://www.instagram.com/igormarantes",
    },
    {
        nome: "Gico",
        curso: "Química, UFSCar",
        ano: "2019",
        foto: "16",
        insta: "https://www.instagram.com/giovanni_mandarino",
    },
    {
        nome: "Hill",
        curso: "Engenharia de Produção, UFSCar",
        ano: "2019",
        foto: "27",
        insta: "https://www.instagram.com/mathias.hilbert",
    },
    {
        nome: "Jin",
        curso: "Engenharia de Produção, UFSCar",
        ano: "2020",
        foto: "7",
        insta: "https://www.instagram.com/jinq_h",
    },
    {
        nome: "Gito",
        curso: "Engenharia Mecânica, UFSCar",
        ano: "2020",
        foto: "5",
        insta: "https://www.instagram.com/gitojunqueira",
    },
    {
        nome: "Math",
        curso: "Engenharia de Produção, CAASO",
        ano: "2020",
        foto: "4",
        insta: "https://www.instagram.com/matvpvasconcelos",
    },
    {
        nome: "Pagode",
        curso: "Engenharia Civil, UFSCar",
        ano: "2020",
        foto: "3",
        insta: "https://www.instagram.com/gabrielzechelv",
    },
    {
        nome: "Bruxo",
        curso: "Engenharia Civil, CAASO",
        ano: "2020",
        foto: "14",
        insta: "https://www.instagram.com/menozzi_",
    },
    {
        nome: "Sampa",
        curso: "Engenharia Civil, UFSCar",
        ano: "2021",
        foto: "28",
        insta: "https://www.instagram.com/als.pedro",
    },
    {
        nome: "Dona Lu",
        curso: "Mãezona da casa",
        ano: "2021",
        foto: "26",
        insta: "https://www.instagram.com/lucia13santos0",
    },
    {
        nome: "Bola",
        curso: "Engenharia de Materiais, UFSCar",
        ano: "2022",
        foto: "17",
        insta: "https://www.instagram.com/joaodmartini",
    },
    {
        nome: "Soca",
        curso: "Estatística e Cicência de Dados, CAASO",
        ano: "2022",
        foto: "9",
        insta: "https://www.instagram.com/morroni_jr",
    },
    {
        nome: "Mister",
        curso: "Engenharia Civil, UFSCar",
        ano: "2022",
        foto: "15",
        insta: "https://www.instagram.com/albert.lages",
    },
    {
        nome: "Dudu",
        curso: "Engenharia Civil, UFSCar",
        ano: "2023",
        foto: "10",
        insta: "https://www.instagram.com/dudu.ferraro",
    },
    {
        nome: "Kenner",
        curso: "Estatística e Cicência de Dados, CAASO",
        ano: "2023",
        foto: "13",
        insta: "https://www.instagram.com/igorb_amoroso",
    },
    {
        nome: "Menex",
        curso: "Engenharia Mecânica, UFSCar",
        ano: "2023",
        foto: "11",
        insta: "https://www.instagram.com/ze_menex",
    },
    {
        nome: "Pinguim",
        curso: "Física Licenciatura, UFSCar",
        ano: "2023",
        foto: "12",
        insta: "https://www.instagram.com/caio_braga1405",
    },
    {
        nome: "Canastra",
        curso: "Engenharia Elétrica, CAASO",
        ano: "2023",
        foto: "1",
        insta: "https://www.instagram.com/sodow.pedro",
    },
    {
        nome: "Vini",
        curso: "Bacharelado em Sistemas de Informação, CAASO",
        ano: "2023",
        foto: "2",
        insta: "https://www.instagram.com/vinivrd",
    },
    {
        nome: "Deco",
        curso: "Engenharia Destrutiva",
        ano: "2023",
        foto: "20",
        insta: "",
    },
    {
        nome: "Sorriso",
        curso: "Educação Física, UFSCAR",
        ano: "2024",
        foto: "25",
        insta: "https://www.instagram.com/mat.sorriso",
    },
    {
        nome: "Alexo",
        curso: "Licenciatura em Química, UFSCAR",
        ano: "2024",
        foto: "21",
        insta: "https://www.instagram.com/gabriel_nassuatto",
    },
    {
        nome: "Letreco",
        curso: "Estatística e Cicência de Dados, CAASO",
        ano: "2024",
        foto: "24",
        insta: "https://www.instagram.com/andre.porta_",
    },
    {
        nome: "Cansado",
        curso: "Bacharelado em Física, UFSCAR",
        ano: "2024",
        foto: "22",
        insta: "https://www.instagram.com/nadermurilo",
    },
    {
        nome: "Pressa",
        curso: "Engenharia de Materiais, UFSCAR",
        ano: "2024",
        foto: "23",
        insta: "https://www.instagram.com/lucasopressa",
    },
    {
        nome: "Peladão",
        curso: "Educação Física, UFSCAR",
        ano: "2025",
        foto: "29",
        insta: "https://www.instagram.com/paiao_math06/",
    },
    {
        nome: "Jussara",
        curso: "Engenharia de Materiais, UFSCAR",
        ano: "2025",
        foto: "30",
        insta: "https://www.instagram.com/leonardo.morato2/",
    },
    {
        nome: "Chapini",
        curso: "Engenharia fisica, UFSCAR",
        ano: "2025",
        foto: "31",
        insta: "https://www.instagram.com/rafaec_02/",
    },
    {
        nome: "Judas",
        curso: "Engenharia de Materiais, CAASO",
        ano: "2025",
        foto: "32",
        insta: "https://www.instagram.com/gabrielcampano_/",
    },
    {
        nome: "Djoko",
        curso: "Cachorro do carai",
        ano: "2025",
        foto: "33",
        insta: "",
    },
];

export default moradores;
